"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.immutableAddToSet = immutableAddToSet;
exports.immutableRemoveFromSet = immutableRemoveFromSet;
exports.substractSets = substractSets;
exports.mergeSets = mergeSets;
/**
 * Adds an element to a set without mutating the original set
 * @param set
 * @param element
 * @returns new set with the added element
 */
function immutableAddToSet(set, element) {
    const newSet = new Set(set);
    newSet.add(element);
    return newSet;
}
/**
 * Removes an item from a set without mutating the original set
 * @param set
 * @param element
 * @returns new set with the element removed
 */
function immutableRemoveFromSet(set, element) {
    const newSet = new Set(set);
    newSet.delete(element);
    return newSet;
}
/**
 * Remove all items from `setA` that exist in `setB` without mutating `setA`.
 * @param setA
 * @param setB
 * @returns new set matching `setA` without the values from `setB`
 */
function substractSets(setA, setB) {
    const newSet = new Set(setA);
    setB.forEach((item) => newSet.delete(item));
    return newSet;
}
/**
 * Merges the values from `setA` and `setB` without mutating.
 * @param setA
 * @param setB
 * @returns new set with the distinct values from `setA` and `setB`
 */
function mergeSets(setA, setB) {
    const newSet = new Set(setA);
    setB.forEach((item) => newSet.add(item));
    return newSet;
}
//# sourceMappingURL=sets.js.map